export default function (title, path, firstInit) {
    let newsTitles = document.querySelectorAll('h1');
    newsTitles.forEach(function (item) {
        if (firstInit || path === item.getAttribute('path')) {
           let closestOnTheIOTrackingElement = item.closest('.next-article').querySelector('.ontheioViewTacking');
           if(closestOnTheIOTrackingElement !== null) closestOnTheIOTrackingElement.setAttribute('data-io-article-url', window.location.href);
        }
    })
}